/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import{getGeometryZScaler as e}from"../../../geometry/support/zscale.js";function t(t,o,r){if(!r?.features||!r.hasZ)return;const f=e(r.geometryType,o,t.outSpatialReference);if(null!=f)for(const e of r.features)f(e.geometry)}export{t as applyFeatureSetZUnitScaling};
